
import {Component, Vue} from 'vue-property-decorator'

@Component
export default class ConfirmDialog extends Vue {
  private showConfirm = false
  private tips = '是否确认？'
  private okText = '确认'
  private cancelText = '取消'
}
